import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CashRequest } from '../../../../core/services/dataBean/EntityCatalog';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const CashRequestConstantSelector = ({ idSelector, onChange, label }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_CashRequest)
    const [id, setID] = useState(0);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }

    const getLista = () => {

        instance.getCashRequestStateConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Estado de la Solicitud"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}